import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "./common/Header";
import Footer from "./common/Footer";
import { callApi } from "./common/API/Api";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import LocomotiveScroll from "locomotive-scroll";
import "locomotive-scroll/dist/locomotive-scroll.css";
import { getBaseUrl } from "./common/BaseUrl";
const Regulation = () => {
let base_url = getBaseUrl();
  function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
      const mql = window.matchMedia(query);
      const handler = e => setMatches(e.matches);
      mql.addEventListener('change', handler);
      setMatches(mql.matches);
      return () => mql.removeEventListener('change', handler);
    }, [query]);
    return matches;
  }

  const isDesktop = useMediaQuery('(min-width: 1402px)');
  const wrapperRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  let base_image_url = process.env.REACT_APP_IMAGE_URL;
  const [pagedata, setPagedata] = useState();
  const location = useLocation();
  const canonicalURL = `https://equlix.com${location.pathname}`;
  // useEffect(() => {
  //   if (!isDesktop) return;
  //   const handleScroll = () => {
  //     setScrollTop(-(window.pageYOffset || document.documentElement.scrollTop));
  //   };

  //   const handleResize = () => {
  //     if (wrapperRef.current) {
  //       document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
  //     }
  //   };

  //   // Initial setup
  //   if (wrapperRef.current) {
  //     document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
  //     document.body.style.overflow = "auto";

  //     wrapperRef.current.style.transition = "transform 0.3s ease-out";
  //     wrapperRef.current.style.position = "fixed";
  //     wrapperRef.current.style.top = "0";
  //     wrapperRef.current.style.left = "0";
  //     wrapperRef.current.style.width = "100%";
  //     wrapperRef.current.style.padding = "0";
  //     wrapperRef.current.style.zIndex = "2";
  //     wrapperRef.current.style.display = "block";
  //     wrapperRef.current.style.backfaceVisibility = "hidden";
  //   }

  //   // Add scroll and resize listeners
  //   window.addEventListener("scroll", handleScroll);
  //   window.addEventListener("resize", handleResize);

  //   // Cleanup on component unmount
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, [isDesktop, wrapperRef?.current?.offsetHeight]);
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.transform = `translateY(${scrollTop}px)`;
    }
  }, [scrollTop]);
  useEffect(() => {
    document.body.style.backgroundColor = "#000000";
    return () => {
      document.body.style = {};
    };
  }, []);
  const pagecontent = useCallback(async ()=>{
try {
    let langcode = base_url.split("/")[1]
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/get-regulations-page?lang=${langcode}`,
        "GET"
      );
      if (res?.data?.success) {
        setPagedata(res?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  },[base_url])
 
  useEffect(() => {
    pagecontent();
  }, [pagecontent]);
 
   useEffect(() => {
    if (!wrapperRef.current) return;

    const scroll = new LocomotiveScroll({
      el: wrapperRef.current,
      smooth: true,
    });

    return () => scroll.destroy(); 
  }, []);

  return (
    <div className="home">
       <style>
         {`
          html.lenis,
          html.lenis body {
            height: auto !important;
          }
        `}
      </style>
      <Helmet>
        <title>{pagedata?.meta?.meta_title || "Equlix"}</title>

        <meta
          name="description"
          content={pagedata?.meta?.meta_description || "About Equlix"}
        />
        <meta
          name="keywords"
          content={pagedata?.meta?.meta_keywords || "Equlix Trading Platform"}
        />
        <link rel="canonical" href={canonicalURL} />
      </Helmet>
      <div className="main-page" ref={wrapperRef} >
        <Header />
        <section className="policyConditions allpagecontent">
          <div className="container topBorder">
            <div className="row">
              <div className="col-xl-12">
                <div
                  className="sec_title text-left"
                  dangerouslySetInnerHTML={{
                    __html: pagedata?.description?.description,
                  }}
                ></div>
              </div>
              <div className="col-12 mt-4">
                <div className="cardBox">
                  <h5 className="m-0 mb-4">Download Certificate:</h5>
                  <figure className="m-0 certificate_img">
                    <a
                      href={base_image_url + pagedata?.content?.image}
                      download
                    >
                      <img
                        src={base_image_url + pagedata?.content?.image}
                        alt=""
                      />
                    </a>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default Regulation;
